"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var nativeError_exports = {};
__export(nativeError_exports, {
  missingNativeBuild: () => missingNativeBuild,
  rethrowNativeError: () => rethrowNativeError
});
module.exports = __toCommonJS(nativeError_exports);
function rethrowNativeError(error) {
  if (error instanceof Error) {
    var message = error.message.trimEnd();
    var coded = /(?:^|:\s)((?:E|ERR)_[A-Z0-9_]+): ([\s\S]*)$/.exec(message);
    error.message = coded ? coded[2] : message;
    if (coded) Object.assign(error, {
      code: coded[1]
    });
  }
  throw error;
}
function missingNativeBuild(operation) {
  return new Error(`${operation} needs an iOS or Android build`);
}
//# sourceMappingURL=nativeError.js.map
